import { useState, useEffect } from "react";
import { AiOutlineArrowRight } from "react-icons/ai";
import { Link } from "react-router-dom";
const HeroSection = () => {
  const images = [
    {
      image:
        "https://img.freepik.com/free-photo/majestic-mountain-peak-tranquil-winter-landscape-generated-by-ai_188544-15662.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777",
      title: "Trade Smarter with AI & Automation",
      subtitle:
        "Teirrax makes trading easy and efficient with AI-powered bots and traditional strategies. Let technology do the work while you focus on profits.",
    },
    {
      image:
        "https://img.freepik.com/free-photo/ultra-detailed-nebula-abstract-wallpaper-4_1562-749.jpg?uid=R176823449&ga=GA1.1.1433286368.1718702777",
      title: "Trade Smarter, Trade Faster",
      subtitle:
        "Trade faster and smarter with AI bots and real-time insights. Let technology simplify your trading journey.",
    },
    
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full">
      {/* Image Slider */}
      <div className="relative overflow-hidden rounded-lg shadow-lg h-[600px]">
        {images.map((image, index) => (
          <div key={index}>
            <img
              key={index}
              src={image.image}
              alt={`Slide ${index + 1}`}
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
                index === currentIndex ? "opacity-100" : "opacity-0"
              }`}
            />
            <div
              className={`absolute inset-0 w-full h-full lg:ml-10 flex items-center justify-start p-10 transition-opacity duration-1000 ${
                index === currentIndex ? "opacity-100" : "opacity-0"
              }`}
            >
              <div className="lg:max-w-2xl bg-black/40 p-3 sm:p-6 lg:mx-0 mx-6 rounded-sm border-white/50 border">
                <h1 className="text-4xl font-semibold text-white">{image.title}</h1>
                <p className="mt-2 text-gray-300 text-base">{image.subtitle}</p>
               <Link to='/registration'>
                <button className=" mt-4 bg-gradient-to-r  from-[#e0e21e] to-[#cacd0d] text-white py-1 px-1 rounded-full flex items-center gap-2 hover:from-[#cdcf36] hover:to-[#d7da27] transition-all duration-300 shadow-lg">
                <span className=" bg-gradient-to-r from-[#0089bd] to-[#059ad4] text-[#fff] px-5 py-2 rounded-full font-semibold">
                Start Trading
                </span>
                <div className="bg-[#0089bd] rounded-full p-2 flex items-center justify-center">
                  <AiOutlineArrowRight className="w-5 h-5 text-[#fcfcfcfa]" />
                </div>
              </button>
              </Link>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Buttons */}
      <button
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-gray-800/70 text-white p-3 rounded-full shadow-lg hover:bg-gray-900 transition"
        onClick={prevSlide}
      >
        &#10094;
      </button>
      <button
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-gray-800/70 text-white p-3 rounded-full shadow-lg hover:bg-gray-900 transition"
        onClick={nextSlide}
      >
        &#10095;
      </button>

      {/* Dots Indicator */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
        {images.map((_, index) => (
          <span
            key={index}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentIndex ? "bg-gray-900 scale-125" : "bg-gray-400"
            }`}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default HeroSection;
